export default __webpack_public_path__ + "static/media/medium_logo_white.44b657b8.svg";